export enum RedirectTypeEnum {
  HOSTED = 'hosted',
  GAME = 'game'
}
